(function () {
const RACES = window.RACE_DB || [];
// ページごとの違い（国内100km未満のページは window.RACE_DB_CONF で差し替える）
const CONF = Object.assign({
  cats: { '100km級': '#3d7ea6', '100マイル級': '#2f6b3f', '200km級': '#b5651d', '300km以上': '#8c2f39' },
  regions: ['アジア', 'オセアニア', 'ヨーロッパ', '北米', '南米', 'アフリカ', '中東'],
  countryAll: 'すべての国', countryOrder: null
}, window.RACE_DB_CONF || {});
const CAT_HEX = CONF.cats, CAT_COLOR = CONF.cats;
const REGION_ORDER = CONF.regions;
const $ = id => document.getElementById(id);
const esc = s => String(s ?? '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

function month(r) { const d = r.date || (r.event_dates && r.event_dates[0]); return d ? +d.slice(5, 7) : null; }
function fmtDate(r) {
  const d = r.event_dates && r.event_dates[0] ? r.event_dates : [r.date, r.date];
  if (!d[0]) return '日程未発表';
  const f = s => { const [y, m, dd] = s.split('-'); return `${y}年${+m}月${+dd}日`; };
  if (!d[1] || d[0] === d[1]) return f(d[0]);
  const [y2, m2, d2] = d[1].split('-');
  return d[0].slice(0, 7) === d[1].slice(0, 7) ? `${f(d[0])}〜${+d2}日` : `${f(d[0])}〜${+m2}月${+d2}日`;
}
function spec(label, v, unit) {
  return `<div><span>${label}</span>${v == null || v === '' ? '<b class="na">—</b>' : `<b>${esc(v)}${unit}</b>`}</div>`;
}
// 「要確認」を含む文は表に出さない（データ側には残す）
function cleanNote(n) {
  if (!n) return '';
  return n.split(/(?<=[。．])|、(?=[^、]*(?:要確認|ミノリ|取込|手動追加|既存DB|DB未収録))/).filter(x => x && !/要確認|既存DB|DB未収録|races_all|ミノリ|取込|手動追加/.test(x)).join('').replace(/^[、。\s]+|[、\s]+$/g, '');
}
function fmtLimit(t) {
  if (!t) return null;
  const m = /^(\d+):(\d+)$/.exec(t);
  return m ? (m[2] === '00' ? `${+m[1]}時間` : `${+m[1]}時間${+m[2]}分`) : t;
}

function fillSelect(el, values, label = v => v) {
  values.forEach(v => el.insertAdjacentHTML('beforeend', `<option value="${esc(v)}">${esc(label(v))}</option>`));
}
fillSelect($('region'), REGION_ORDER.filter(r => RACES.some(x => x.region === r)));
fillSelect($('month'), [...Array(12)].map((_, i) => i + 1), m => `${m}月`);
fillSelect($('cat'), Object.keys(CONF.cats));
function refreshCountries() {
  const reg = $('region').value, cur = $('country').value;
  const list = [...new Set(RACES.filter(r => !reg || r.region === reg).map(r => r.country).filter(Boolean))].sort((a, b) => CONF.countryOrder ? CONF.countryOrder.indexOf(a) - CONF.countryOrder.indexOf(b) : (b === '日本') - (a === '日本') || a.localeCompare(b, 'ja'));
  $('country').innerHTML = `<option value="">${CONF.countryAll}</option>`;
  fillSelect($('country'), list);
  if (list.includes(cur)) $('country').value = cur;
}
refreshCountries();

const map = L.map('map', { scrollWheelZoom: false, minZoom: 1, zoomSnap: 0.25, maxBounds: [[-75, -30], [85, 330]], maxBoundsViscosity: 1 }).setView([30, 20], 2);
L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  maxZoom: 12, attribution: '&copy; OpenStreetMap contributors'
}).addTo(map);
const layer = L.layerGroup().addTo(map);
let lastPts = [];
// ページの組み立てが終わる前だと地図の大きさを読み違えるので、大きさを測り直してから合わせる
function fitMap() {
  map.invalidateSize();
  // 地図の幅が世界1周分を超えるとアメリカ大陸が両端に出るので、それより引けないようにする
  map.setMinZoom(Math.max(1, Math.ceil(Math.log2(map.getSize().x / 256) * 4) / 4));
  if (lastPts.length) map.fitBounds(lastPts, { padding: [30, 30], maxZoom: 7 });
}
window.addEventListener('load', fitMap);
window.addEventListener('resize', () => { clearTimeout(fitMap.t); fitMap.t = setTimeout(fitMap, 200); });

function render() {
  const q = $('q').value.trim().toLowerCase(), reg = $('region').value, ct = $('country').value,
        mo = +$('month').value || null, cat = $('cat').value, fmt = $('fmt').value, jf = $('jaaf').value;
  const hit = RACES.filter(r =>
    (!q || `${r.event} ${r.race} ${r.alias || ''} ${r.place} ${r.country} ${r.course || ''}`.toLowerCase().includes(q)) &&
    (!reg || r.region === reg) && (!ct || r.country === ct) &&
    (!mo || month(r) === mo) && (!cat || r.category === cat) &&
    (!fmt || r.course === fmt) && (!jf || (jf === '1') === !!r.jaaf));

  $('count').textContent = `${hit.length} 件`;

  layer.clearLayers();
  const pts = [];
  // 同じ地点の種目（例：比叡山の3種目）はピンを1つにまとめ、ポップアップに全種目を並べる（ずらすと実際の場所から離れるため）
  const groups = {}, order = [];
  hit.forEach(r => {
    if (r.lat == null || r.lng == null) return;
    const k = r.lat.toFixed(3) + ',' + r.lng.toFixed(3);
    if (!groups[k]) { groups[k] = []; order.push(k); }
    groups[k].push(r);
  });
  order.forEach(k => {
    const rs = groups[k], r0 = rs[0];
    // 太平洋を真ん中にするため、西経30度より西（南北アメリカ）は右側に回す
    const lat = r0.lat, lng = r0.lng < -30 ? r0.lng + 360 : r0.lng;
    pts.push([lat, lng]);
    const one = r => `<b>${esc(r.event)}</b><br>${esc(r.race)}<br>${fmtDate(r)}<br>${r.distance_km != null ? r.distance_km + 'km' : (r.time_format_h ? r.time_format_h + '時間走' : '')} / 制限時間 ${fmtLimit(r.time_limit) || '—'}${r.capacity != null ? ` / 定員 ${r.capacity.toLocaleString()}人` : ''}<br><a href="${esc(r.url)}" target="_blank" rel="noopener">公式サイト</a>`;
    // まとめたピンには種目数を表示し、重なっていることが分かるようにする
    const pin = rs.length > 1
      ? L.marker([lat, lng], { icon: L.divIcon({ className: '', iconSize: [24, 24], iconAnchor: [12, 12],
          html: `<div style="width:24px;height:24px;border-radius:50%;background:${CAT_HEX[r0.category]};border:2px solid #fff;box-sizing:border-box;color:#fff;font:bold 12px/20px sans-serif;text-align:center;box-shadow:0 0 2px rgba(0,0,0,.4)">${rs.length}</div>` }) })
      : L.circleMarker([lat, lng], { radius: 7, weight: 2, color: '#fff', fillColor: CAT_HEX[r0.category], fillOpacity: .9 });
    pin
      .bindPopup(rs.map(one).join('<hr style="margin:6px 0;border:0;border-top:1px solid #ddd">'), { maxHeight: 260 })
      .addTo(layer);
  });
  lastPts = pts;
  fitMap();

  if (!hit.length) { $('list').innerHTML = '<div class="empty">条件に合うレースがありません</div>'; return; }
  const today = new Date().toISOString().slice(0, 10);
  const startOf = r => r.date || (r.event_dates && r.event_dates[0]) || null;
  const endOf = r => (r.event_dates && r.event_dates[1]) || startOf(r);
  const isPast = r => !startOf(r) || endOf(r) < today;
  const ordered = [...hit.filter(r => !isPast(r)).sort((a, b) => startOf(a).localeCompare(startOf(b))), ...hit.filter(isPast)];
  let html = '', cur = '';
  ordered.forEach(r => {
    const key = isPast(r) ? '開催済み・日程未定（次回日程は未発表）' : `${startOf(r).slice(0, 4)}年${+startOf(r).slice(5, 7)}月`;
    if (key !== cur) { if (cur) html += '</div>'; html += `<div class="month">${key}</div><div class="list">`; cur = key; }
    html += `<article class="card">
      <div class="top"><h3>${esc(r.event)}</h3><div class="tags">${r.jaaf ? '<span class="tag jaaf">陸連公認</span>' : ''}${r.course ? `<span class="tag stage">${esc(r.course)}</span>` : ''}<span class="tag" style="background:${CAT_COLOR[r.category]}">${esc(r.category)}</span></div></div>
      <div class="race">${esc(r.race)}</div>
      <div class="meta">${fmtDate(r)}｜${esc(r.country || '')} ${esc((r.place || '').replace(/[（(][^）)]*要確認[^）)]*[）)]/g, '').replace(/要確認/g, ''))}</div>
      <div class="specs">${spec('距離', r.distance_km != null ? r.distance_km : (r.time_format_h ? r.time_format_h + '時間走' : null), r.distance_km != null ? 'km' : '')}${spec('制限時間', fmtLimit(r.time_limit), '')}${spec('定員', r.capacity != null ? r.capacity.toLocaleString() : null, '人')}</div>
      ${r.dplus_m != null ? `<div class="note">累積標高 約${r.dplus_m.toLocaleString()}m</div>` : ''}${r.elev_diff_m != null ? `<div class="note">コースの高低差 約${r.elev_diff_m}m</div>` : ''}${r.qualification ? `<div class="note">参加資格・関門：${esc(r.qualification)}</div>` : ''}${cleanNote(r.note) ? `<div class="note">${esc(cleanNote(r.note))}</div>` : ''}
      <a class="link" href="${esc(r.url)}" target="_blank" rel="noopener">公式サイトを見る →</a>
    </article>`;
  });
  $('list').innerHTML = html + '</div>';
}

$('region').addEventListener('change', () => { refreshCountries(); render(); });
['country', 'month', 'cat', 'fmt', 'jaaf'].forEach(id => $(id).addEventListener('change', render));
$('q').addEventListener('input', render);
$('reset').addEventListener('click', () => { ['q', 'region', 'month', 'cat', 'fmt', 'jaaf'].forEach(id => $(id).value = ''); refreshCountries(); $('country').value = ''; render(); });
render();

})();
